exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.navbar .dropdown-menu{max-height:70vh;overflow-y:auto\n}\n@media(max-width: 767.98px){\n#nav-collapse{max-height:calc(100vh - 56px);overflow-y:auto\n}\n}", ""]);

// exports
